export default "__VITE_ASSET__DhxKKnbn__"